import { create } from 'zustand'
import * as api from '../api'

type Status = 'loading' | 'setup' | 'login' | 'authenticated'

interface State {
  status: Status
  user: api.AuthUser | null
  checkAuth: () => Promise<void>
  login: (email: string, password: string) => Promise<void>
  setup: (email: string, name: string, password: string) => Promise<void>
  logout: () => Promise<void>
}

export const useAuthStore = create<State>((set) => ({
  status: 'loading',
  user: null,
  checkAuth: async () => {
    try {
      const s = await api.auth.checkSetup()
      if (s.needsSetup) { set({ status: 'setup' }); return }
    } catch {
      set({ status: 'setup' }); return
    }
    try {
      const me = await api.auth.me()
      set({ status: 'authenticated', user: me.user })
    } catch {
      set({ status: 'login' })
    }
  },
  login: async (email, password) => {
    const res = await api.auth.login(email, password)
    set({ status: 'authenticated', user: res.user })
  },
  setup: async (email, name, password) => {
    const res = await api.auth.setup({ email, name, password })
    set({ status: 'authenticated', user: res.user })
  },
  logout: async () => {
    try { await api.auth.logout() } catch { /* */ }
    set({ status: 'login', user: null })
  },
}))
